<template>
  <div class="footer" ref="footer" id="home-footer">
    <div class="footer-top">
      <div class="content">
        <img :src="static_img_url+'pic/vbef-logo.png?v=' + $store.state.imgVersion" class="logo" v-if="language == 'zh'" />
        <img :src="static_img_url+'pic/vbef-logo-en.png?v=' + $store.state.imgVersion" class="logo" v-if="language == 'en'" />
        <p class="p2">{{'重庆市渝北区金星科技大厦A区5楼512室' | dealLanguage('Room 512, 5th Floor, Block A, Jinxing Technology Building, Yubei District, Chongqing')}}</p>
        <p class="p2">{{'联系电话：023-67685030（重庆）' | dealLanguage('TEL：023-67685030(Chongqing)')}}</p>

        <div class="link">
          <div class="link-title">{{'关于我们' | dealLanguage('ABOUT US')}}</div>
          <div class="link-list">
            <div><a :href="index2_path + '/Index/Index/companyInfo'" target="_blank">{{'关于动脉网' | dealLanguage('about vcbeat')}}</a></div>
            <div><a :href="index2_path + '/Index/Index/aboutUs'" target="_blank">{{'联系我们' | dealLanguage('contact us')}}</a></div>
            <div><a href="https://vcbeat.zhiye.com/Campus" target="_blank">{{'加入我们' | dealLanguage('join us')}}</a></div>
            <div><a href="https://support.qq.com/products/340682" target="_blank" rel="nofollow">{{'意见反馈' | dealLanguage('feedback')}}</a></div>
          </div>
        </div>
        <div class="link" v-if="btnList.length">
          <div class="link-title">{{'快捷入口' | dealLanguage('Quick entrance')}}</div>
          <div class="link-list">
            <div v-for="item,index in btnList" :key="index"><a @click="clickBanner(item, 'footer')">{{item.description}}</a></div>
          </div>
        </div>

        <div class="right">
          <div class="ewm-item">
            <p class="title">{{'联系我们' | dealLanguage('Contact Us')}}</p>
            <img :src="static_img_url + 'pic/xiaoqiang.png?v=' + $store.state.imgVersion" />
            <p class="p1">{{'动脉网-翁先生' | dealLanguage('VBEF-Mr.Weng')}}</p>
          </div>
          <div class="ewm-item">
            <p class="title">{{'关注我们' | dealLanguage('Follow Us')}}</p>
            <img :src="static_img_url + 'pic/vbef-code.png?v=' + $store.state.imgVersion" />
            <p class="p1">{{'VBEF订阅号' | dealLanguage('VBEF-Official Account')}}</p>
          </div>
          <div class="ewm-item">
            <!--<img :src="static_img_url + 'pic/xiaomeng.png?v=' + $store.state.imgVersion" />
            <p class="p1">动脉网-小萌</p>-->
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <a href="http://beian.miit.gov.cn" target="_blank">© 动脉橙 渝ICP备18013108号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165">
        <img :src="img_req_url + '/upload/vcbeat/public/images/pb-icon.png?v=' + $store.state.imgVersion" />
        渝公网安备 50011202502165号
      </a>
      <a href="javascript:void(0)" @click="certificate_model = true">互联网药品信息服务资格证书：（渝）-非经营性-2023-0083</a>
    </div>
    <Modal class="certificate-model" v-model="certificate_model" width="960" :footer-hide="true">
      <img :src="static_img_url + 'pic/certificate.jpg'" class="certificate-img" />
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  inject: ['clickBanner'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      certificate_model: false,
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
      language: (state) => state.language,
    }),
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.footer
  width 100%
  .footer-top
    margin 0 auto
    padding 0.4rem
    .content
      .logo
        display block
        width auto
        height 0.36rem
        font-size 0
        &+.p2
          margin-top 0.3rem
      .p2
        font-size 0.22rem
        color #333333
        line-height 0.31rem
        &+.p2
          margin-top 0.25rem
      .link
        margin-top 0.5rem
        .link-title
          font-size 0.3rem
          color #333333
          line-height 0.42rem
          font-weight 600
        .link-list
          margin-top 0.35rem
          display flex
          flex-wrap wrap
          justify-content space-between
          > div:first-of-type
            flex 0 0 1.4rem
            white-space nowrap
          a
            font-size 0.26rem
            color #333333
            line-height 0.36rem
      .right
        display flex
        justify-content space-between
        margin-top 0.47rem
        .ewm-item
          flex 0 0 2rem
          display flex
          flex-direction column
          align-items center
          position relative
          padding-top 0.6rem
          img
            width 2rem
            height 2rem
          .p1
            font-size 0.22rem
            color #6D6D6D
            line-height 0.31rem
            margin-top 0.1rem
            white-space nowrap
          .title
            position absolute
            font-size 0.3rem
            color #333333
            line-height 0.42rem
            font-weight 600
            left 0
            top 0
  .footer-bottom
    width 100%
    padding 0.16rem 0
    background #000
    text-align center
    display flex
    align-items center
    justify-content space-evenly
    flex-wrap wrap
    a
      font-size 0.22rem
      color #fff
      display flex
      align-items center
      margin 0.08rem
      img
        margin-right 0.04rem
        width 0.16rem
      &:active
        color #FA5A00
.certificate-model
  >>> .ivu-modal-content
    border-radius 0
    .ivu-modal-close
      .ivu-icon-ios-close
        color #fff
    .ivu-modal-body
      padding 0
      font-size 0
.certificate-img
  width 100%
</style>
